export default "__VITE_ASSET__DJoJ6mN7__"